import React from 'react';
import { Badge, Button, CircularProgress, Tooltip } from '@mui/material';

const INTENT_MAP = {
  primary:   { variant: 'contained', color: 'primary' },
  secondary: { variant: 'outlined',  color: 'primary' },
  ghost:     { variant: 'text',      color: 'inherit'  },
  danger:    { variant: 'contained', color: 'error'    },
  success:   { variant: 'contained', color: 'success'  },
  warning:   { variant: 'contained', color: 'warning'  },
};

const ActionButton = ({
  onClick,
  label,
  icon,
  endIcon,
  variant,
  color,
  intent,
  size = 'medium',
  badgeContent = 0,
  badgeColor = 'primary',
  tooltip,
  disabled = false,
  loading = false,
  fullWidth = false,
  sx = {},
}) => {
  let resolvedVariant = variant;
  let resolvedColor   = color;

  if (intent && INTENT_MAP[intent]) {
    resolvedVariant = INTENT_MAP[intent].variant;
    resolvedColor   = INTENT_MAP[intent].color;
  }

  if (badgeContent > 0 && !resolvedVariant) {
    resolvedVariant = 'contained';
  }

  resolvedVariant = resolvedVariant || 'outlined';
  resolvedColor   = resolvedColor   || 'primary';

  let finalTooltip = tooltip;
  if (!finalTooltip && badgeContent > 0) {
    finalTooltip = `${badgeContent} ${label.toLowerCase()} active`;
  }
  if (!finalTooltip && label) {
    finalTooltip = `Open ${label.toLowerCase()}`;
  }

  const spinnerSize = size === 'small' ? 12 : size === 'large' ? 18 : 14;
  const startIcon = loading
    ? <CircularProgress size={spinnerSize} color="inherit" />
    : icon;

  const button = (
    <Button
      variant={resolvedVariant}
      color={resolvedColor}
      size={size}
      onClick={onClick}
      disabled={disabled || loading}
      startIcon={startIcon}
      endIcon={!loading ? endIcon : undefined}
      fullWidth={fullWidth}
      sx={{
        fontWeight: 600,
        ...(resolvedVariant === 'text' && resolvedColor === 'inherit'
          ? { color: 'text.secondary', '&:hover': { color: 'text.primary' } }
          : {}),
        ...sx,
      }}
    >
      {label}
    </Button>
  );

  const wrapped =
    badgeContent > 0 ? (
      <Badge
        badgeContent={badgeContent}
        color={badgeColor}
        overlap="circular"
      >
        {button}
      </Badge>
    ) : (
      button
    );

  return (
    <Tooltip title={finalTooltip || ''} disableHoverListener={!finalTooltip}>
      <span style={{ display: fullWidth ? 'block' : 'inline-flex' }}>
        {wrapped}
      </span>
    </Tooltip>
  );
};

export default ActionButton;